import React from 'react';
import { useTranslation } from 'react-i18next';

import { Geometry } from '../../../../../../viewer/elements/geometry';
import { useSharedView } from '../../../../../hooks/use-shared-view';
import { useUnitSymbols } from '../../../../../hooks/use-unit-symbols';
import { LabelledContainer } from '../../../../labelled-container/labelled-container';
import { AssetTags } from '../../components/asset-tags';
import { TimelineSection } from '../../components/timeline-section';
import { FullWidth } from '../../styles/grid';
import { numberOrDefault } from '../../utils/formatting';

type Props = {
  asset: Geometry;
  refreshAsset: () => void;
};

const LineBody = (props: Props) => {
  const { t } = useTranslation();
  const { isSharedView } = useSharedView();
  const unitSymbols = useUnitSymbols();

  return (
    <>
      <LabelledContainer text={t('line.section.length3d', { ns: 'skyviewAssetMenu' })}>
        {numberOrDefault(props.asset.getDistance(), unitSymbols.length)}
      </LabelledContainer>
      <LabelledContainer text={t('line.section.length2d', { ns: 'skyviewAssetMenu' })}>
        {numberOrDefault(props.asset.getPlaneDistance(), unitSymbols.length)}
      </LabelledContainer>
      <TimelineSection asset={props.asset} />
      {!isSharedView && props.asset.assetId && (
        <FullWidth>
          <LabelledContainer text={t('fileManager.actionBar.tags', { ns: 'components' })}>
            <AssetTags
              initialTagsIds={props.asset.assetTagIds}
              refreshAsset={props.refreshAsset}
              target={{ kind: 'dynamicAsset', id: props.asset.assetId, name: props.asset.name }}
            />
          </LabelledContainer>
        </FullWidth>
      )}
    </>
  );
};

export { LineBody, Props as LineBodyProps };
